/**
 * ПОЛНЫЙ ПУТЬ: D:\QR\QR-WEB\dashboard\src\components\Admin\AdminTransactions\AdminTransactionsPending.js
 * ВЕРСИЯ: 1.0.0
 * ВРЕМЯ СОЗДАНИЯ: 15.11.2025 18:15
 * 
 * ОПИСАНИЕ: Компонент управления ожидающими транзакциями
 * - Список всех транзакций в статусе "в ожидании"
 * - Поиск по ID, email, кошельку
 * - Ручное подтверждение транзакций
 * - Отмена транзакций
 * - Просмотр деталей и логов
 * - Экспорт в CSV
 */

import React, { useState, useEffect } from 'react';
import './AdminTransactionsPending.css';

const AdminTransactionsPending = () => {
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTx, setSelectedTx] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    fetchPendingTransactions();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [transactions, searchQuery]);

  const fetchPendingTransactions = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('authToken');
      const response = await fetch(
        'https://qr-money.onrender.com/api/admin/transactions?status=pending',
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const txList = data.data || data.transactions || data || [];
      const pending = Array.isArray(txList)
        ? txList.filter(t => t.status === 'pending')
        : [];

      setTransactions(pending);
      console.log('✅ Ожидающие транзакции загружены:', pending);
    } catch (err) {
      console.error('❌ Ошибка при загрузке транзакций:', err);
      setError(err.message);
      setTransactions(getMockPendingTransactions());
    } finally {
      setLoading(false);
    }
  };

  const getMockPendingTransactions = () => [
    {
      id: 'TXN-2025-11-16-001',
      type: 'transfer',
      from: 'alice@test.com',
      to: 'business@test.com',
      amount: 100,
      status: 'pending',
      description: 'P2P перевод',
      created_at: '2025-11-15T10:30:00Z',
      tx_hash: null,
      blockchain_confirmations: 0
    },
    {
      id: 'TXN-2025-11-16-002',
      type: 'qr_claim',
      from: 'System',
      to: 'alice@test.com',
      amount: 50,
      status: 'pending',
      description: 'Получение из QR...',
      created_at: '2025-11-15T11:00:00Z',
      tx_hash: null,
      blockchain_confirmations: 0
    },
    {
      id: 'TXN-2025-11-16-003',
      type: 'commission',
      from: 'alice@test.com',
      to: 'System',
      amount: 2.5,
      status: 'pending',
      description: 'Комиссия за перевод',
      created_at: '2025-11-15T09:45:00Z',
      tx_hash: null,
      blockchain_confirmations: 0
    },
    {
      id: 'TXN-2025-11-16-004',
      type: 'payment',
      from: 'business@test.com',
      to: 'System',
      amount: 200,
      status: 'pending',
      description: 'Платёж за услугу',
      created_at: '2025-11-14T16:20:00Z',
      tx_hash: null,
      blockchain_confirmations: 0
    }
  ];

  const applyFilters = () => {
    let filtered = transactions;

    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(t =>
        t.id.toLowerCase().includes(query) ||
        t.from.toLowerCase().includes(query) ||
        t.to.toLowerCase().includes(query)
      );
    }

    setFilteredTransactions(filtered);
  };

  const handleConfirmTransaction = async () => {
    if (!selectedTx) return;

    if (!window.confirm(`Подтвердить транзакцию ${selectedTx.id}?`)) {
      return;
    }

    try {
      setActionLoading(true);
      const token = localStorage.getItem('authToken');

      const response = await fetch(
        `https://qr-money.onrender.com/api/admin/transactions/${selectedTx.id}/confirm`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.ok) {
        setTransactions(transactions.filter(t => t.id !== selectedTx.id));
        setSelectedTx(null);
        alert('✅ Транзакция подтверждена');
      } else {
        const errData = await response.json();
        alert(`❌ Ошибка: ${errData.message || 'при подтверждении'}`);
      }
    } catch (err) {
      console.error('❌ Ошибка:', err);
      alert('❌ Ошибка при подтверждении транзакции');
    } finally {
      setActionLoading(false);
    }
  };

  const handleRejectTransaction = async () => {
    if (!selectedTx) return;

    if (!window.confirm(`Отклонить транзакцию ${selectedTx.id}? Средства будут возвращены.`)) {
      return;
    }

    try {
      setActionLoading(true);
      const token = localStorage.getItem('authToken');

      const response = await fetch(
        `https://qr-money.onrender.com/api/admin/transactions/${selectedTx.id}/reject`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.ok) {
        setTransactions(transactions.filter(t => t.id !== selectedTx.id));
        setSelectedTx(null);
        alert('✅ Транзакция отклонена, средства возвращены');
      } else {
        const errData = await response.json();
        alert(`❌ Ошибка: ${errData.message || 'при отклонении'}`);
      }
    } catch (err) {
      console.error('❌ Ошибка:', err);
      alert('❌ Ошибка при отклонении транзакции');
    } finally {
      setActionLoading(false);
    }
  };

  const handleExportCSV = () => {
    const csv = [
      ['ID', 'Тип', 'От', 'Кому', 'Сумма', 'Статус', 'Дата'].join(','),
      ...filteredTransactions.map(t =>
        [
          t.id,
          t.type,
          t.from,
          t.to,
          t.amount,
          t.status,
          new Date(t.created_at).toLocaleDateString('ru-RU')
        ].join(',')
      )
    ].join('\n');

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `pending_transactions_${Date.now()}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const getTypeLabel = (type) => {
    const labels = {
      transfer: '🔄 Перевод',
      qr_claim: '🎁 Получение из QR',
      commission: '💰 Комиссия',
      payment: '💳 Платёж'
    };
    return labels[type] || type;
  };

  const getTimePending = (createdAt) => {
    const created = new Date(createdAt);
    const now = new Date();
    const diffMinutes = Math.floor((now - created) / 60000);

    if (diffMinutes < 60) return `${diffMinutes} мин назад`;
    if (diffMinutes < 1440) return `${Math.floor(diffMinutes / 60)} ч назад`;
    return `${Math.floor(diffMinutes / 1440)} дн назад`;
  };

  if (loading) {
    return (
      <div className="admin-pending-page">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <p>⏳ Загрузка ожидающих транзакций...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-pending-page">
      {/* ЗАГОЛОВОК */}
      <div className="pending-header">
        <h1>⏳ Ожидающие транзакции</h1>
        <p>Всего в ожидании: {transactions.length} | Показано: {filteredTransactions.length}</p>
      </div>

      {/* ОШИБКА */}
      {error && (
        <div className="error-message">
          ⚠️ {error} (используются тестовые данные)
        </div>
      )}

      {/* КОНТРОЛЫ */}
      <div className="pending-controls">
        <div className="controls-left">
          <input
            type="text"
            className="search-input"
            placeholder="🔍 Поиск по ID, email или кошельку..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="controls-right">
          <button
            className="btn-export"
            onClick={handleExportCSV}
            disabled={filteredTransactions.length === 0}
          >
            📥 Экспорт CSV
          </button>
          <button
            className="btn-refresh"
            onClick={fetchPendingTransactions}
            title="Обновить"
          >
            🔄
          </button>
        </div>
      </div>

      {/* ОСНОВНОЙ КОНТЕНТ */}
      <div className="pending-container">
        {/* ТАБЛИЦА */}
        <div className="pending-table">
          {filteredTransactions.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Тип</th>
                  <th>От</th>
                  <th>Кому</th>
                  <th>Сумма</th>
                  <th>Описание</th>
                  <th>Время</th>
                  <th>Действие</th>
                </tr>
              </thead>
              <tbody>
                {filteredTransactions.map((tx) => (
                  <tr
                    key={tx.id}
                    className={selectedTx?.id === tx.id ? 'active' : ''}
                    onClick={() => setSelectedTx(tx)}
                  >
                    <td className="tx-id">{tx.id}</td>
                    <td className="tx-type">{getTypeLabel(tx.type)}</td>
                    <td className="tx-email">{tx.from}</td>
                    <td className="tx-email">{tx.to}</td>
                    <td className="tx-amount">{tx.amount} DAR</td>
                    <td className="tx-desc">{tx.description}</td>
                    <td className="tx-time">
                      <span className="pending-badge">
                        {getTimePending(tx.created_at)}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn-view"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedTx(tx);
                        }}
                        title="Просмотр"
                      >
                        👁️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="no-transactions">
              <p>✅ Все транзакции обработаны!</p>
            </div>
          )}
        </div>

        {/* ДЕТАЛИ */}
        {selectedTx && (
          <div className="pending-details">
            <div className="details-header">
              <h2>📋 Детали транзакции</h2>
              <button
                className="btn-close"
                onClick={() => setSelectedTx(null)}
                title="Закрыть"
              >
                ✕
              </button>
            </div>

            <div className="details-content">
              <div className="detail-section">
                <h3>Основная информация</h3>
                
                <div className="detail-item">
                  <span className="detail-label">ID</span>
                  <span className="detail-value mono">{selectedTx.id}</span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">Тип</span>
                  <span className="detail-value">{getTypeLabel(selectedTx.type)}</span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">Описание</span>
                  <span className="detail-value">{selectedTx.description}</span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">Статус</span>
                  <span className="status-badge pending">⏳ В ожидании</span>
                </div>
              </div>

              <div className="detail-section">
                <h3>Участники</h3>
                
                <div className="detail-item">
                  <span className="detail-label">От (отправитель)</span>
                  <span className="detail-value">{selectedTx.from}</span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">Кому (получатель)</span>
                  <span className="detail-value">{selectedTx.to}</span>
                </div>
              </div>

              <div className="detail-section">
                <h3>Сумма и комиссии</h3>
                
                <div className="detail-item">
                  <span className="detail-label">Сумма</span>
                  <span className="detail-value amount">{selectedTx.amount} DAR</span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">Комиссия системы</span>
                  <span className="detail-value commission">
                    {(selectedTx.amount * 0.025).toFixed(2)} DAR
                  </span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">Итого (с комиссией)</span>
                  <span className="detail-value total">
                    {(selectedTx.amount * 1.025).toFixed(2)} DAR
                  </span>
                </div>
              </div>

              <div className="detail-section">
                <h3>Времени</h3>
                
                <div className="detail-item">
                  <span className="detail-label">Создана</span>
                  <span className="detail-value">
                    {new Date(selectedTx.created_at).toLocaleString('ru-RU')}
                  </span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">Ожидает</span>
                  <span className="detail-value pending-time">
                    {getTimePending(selectedTx.created_at)}
                  </span>
                </div>
              </div>

              <div className="detail-section">
                <h3>Блокчейн</h3>
                
                <div className="detail-item">
                  <span className="detail-label">Хеш транзакции</span>
                  <span className="detail-value mono">
                    {selectedTx.tx_hash || '⏳ Не отправлено'}
                  </span>
                </div>

                <div className="detail-item">
                  <span className="detail-label">Подтверждения</span>
                  <span className="detail-value">
                    {selectedTx.blockchain_confirmations || 0} конфирмов
                  </span>
                </div>
              </div>

              {/* ДЕЙСТВИЯ */}
              <div className="action-buttons">
                <button
                  className="btn btn-confirm"
                  onClick={handleConfirmTransaction}
                  disabled={actionLoading}
                >
                  ✅ {actionLoading ? 'Обработка...' : 'Подтвердить'}
                </button>
                <button
                  className="btn btn-reject"
                  onClick={handleRejectTransaction}
                  disabled={actionLoading}
                >
                  ❌ {actionLoading ? 'Обработка...' : 'Отклонить'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminTransactionsPending;
